<template>
  <div>
    <!-- 完善信息 -->
    <el-form :model="form" :rules="formRules" ref="formRef" style="width:540px;" label-width="165px" label-position="right" class="form-single">
      <el-form-item label="证件类型：" class="margin-t50">
        <span class="form-single-sp">身份证</span>
      </el-form-item>
      <el-form-item label="证件号码：" class="margin-t-15">
        <span class="form-single-sp">{{form.certificateno}}</span>
      </el-form-item>
      <el-form-item label="证件有效期至：" class="margin-t-15">
        <span class="form-single-sp">{{form.vailddate}}</span>
      </el-form-item>
      <el-form-item label="性别：" class="margin-t-15">
        <span class="form-single-sp">{{form.sex}}</span>
      </el-form-item>
      <el-form-item label="出生日期：" class="margin-t-15">
        <span class="form-single-sp">{{form.birthday}}</span>
      </el-form-item>
      <el-form-item label="国籍：">
        <el-input v-model="form.china" disabled></el-input>
      </el-form-item>
      <el-form-item label="职业：" prop="occupation">
        <el-select v-model="form.occupation" placeholder="请选择职业">
          <el-option v-for="(item,i) in professionArr" :key="i" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址：" prop="province">
        <el-cascader v-model="form.province" :options="optionsZq" placeholder="**请选择**" style="width:375px;"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="address">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item>
        <p class="form-single-line"></p>
      </el-form-item>
      <!-- 控制人，受益人 -->
      <el-form-item label="实际控制人：" prop="controller">
        <el-select v-model="form.controller">
          <el-option label="本人" value="1"></el-option>
          <el-option label="非本人" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="姓名：" prop="controllerName">
        <el-input v-model="form.controllerName" placeholder="实际控制人姓名"></el-input>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="证件类型：" prop="controllerIdType">
        <el-select v-model="form.controllerIdType">
          <el-option label="身份证" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="证件号码：" prop="controllerId">
        <el-input v-model="form.controllerId" placeholder="实际控制人证件号码"></el-input>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="证件有效期：" prop="controllerIdDate">
        <el-date-picker v-model="form.controllerIdDate" style="width:360px;" type="date" :picker-options="pickerOptions" placeholder="实际控制人证件有效期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="联系方式：" prop="controllerPhone">
        <el-input v-model="form.controllerPhone" placeholder="实际控制人联系方式"></el-input>
      </el-form-item>
      <el-form-item v-if="form.controller == '0'" label="情况说明：" prop="controllerExplain">
        <el-input type="textarea" placeholder="情况说明" v-model="form.controllerExplain"></el-input>
      </el-form-item>
      <el-form-item label="实际受益人：" prop="beneficiary">
        <el-select v-model="form.beneficiary">
          <el-option label="本人" value="1"></el-option>
          <el-option label="非本人" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="姓名：" prop="beneficiaryName">
        <el-input v-model="form.beneficiaryName" placeholder="实际受益人姓名"></el-input>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="证件类型：" prop="beneficiaryIdType">
        <el-select v-model="form.beneficiaryIdType">
          <el-option label="身份证" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="证件号码：" prop="beneficiaryId">
        <el-input v-model="form.beneficiaryId" placeholder="实际受益人证件号码"></el-input>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="证件有效期：" prop="beneficiaryIdDate">
        <el-date-picker v-model="form.beneficiaryIdDate" style="width:360px;" type="date" :picker-options="pickerOptions" placeholder="实际受益人证件有效期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="联系方式：" prop="beneficiaryPhone">
        <el-input v-model="form.beneficiaryPhone" placeholder="实际受益人联系方式"></el-input>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label="情况说明：" prop="beneficiaryExplain">
        <el-input type="textarea" placeholder="情况说明" v-model="form.beneficiaryExplain"></el-input>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" label-width="0">
        <p style="margin-left:65px;color:#666;">实际受益人为政要、国际组织高级管理人员或其亲属关系密切的人：</p>
      </el-form-item>
      <el-form-item v-if="form.beneficiary == '0'" prop="radio1">
        <el-radio-group v-model="form.radio1" class="radio-single-one">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 不良诚信记录 -->
      <el-form-item>
        <p class="form-single-line"></p>
      </el-form-item>
      <el-form-item label="是否有不良诚信记录：" prop="radio2">
        <el-radio-group v-model="form.radio2" class="radio-single-one">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.radio2 == 1" prop="illegalContent">
        <el-input type="textarea" placeholder="请描述不良记录" v-model="form.illegalContent"></el-input>
      </el-form-item>
      <el-form-item>
        <p class="form-single-line"></p>
      </el-form-item>
      <!-- 税收居民身份声明 -->
      <el-form-item label="税收居民身份声明：" prop="type">
        <el-select v-model="form.type">
          <el-option label="仅为中国税收居民" value="1"></el-option>
          <el-option label="仅为非居民" value="2"></el-option>
          <el-option label="既是中国税收居民又是其他国家（地区）税收居民" value="3"></el-option>
        </el-select>
      </el-form-item>
      <!-- 仅为非居民 -->
      <el-form-item v-if="form.type == '2'" label="姓：" prop="lastname">
        <el-input v-model="form.lastname" placeholder="英文或拼音"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="名：" prop="firstname">
        <el-input v-model="form.firstname" placeholder="英文或拼音"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="性别：" prop="sexRadio">
        <el-radio-group v-model="form.sexRadio" class="radio-single-one">
          <el-radio :label="'男'">男</el-radio>
          <el-radio :label="'女'">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="出生日期：">
        <datePicker @dateSelected="birthDateClick" v-model="form.birthDate" :sourceDate="sourceDate"></datePicker>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="现居地址国家：" prop="nowCountry">
        <el-select v-model="form.nowCountry">
          <el-option v-for="(item,i) in countryListArr" :key="i" :label="item.name" :value="item.short"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="现居地址城市：" prop="nowCity">
        <el-input v-model="form.nowCity" placeholder="英文或拼音"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" prop="nowAddress">
        <el-input v-model="form.nowAddress" placeholder="街道 | 楼号 | 房门号 | 楼层 | 区 | 邮箱 | 邮编 | 行政区划"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="出生地址国家：" prop="bornCountry">
        <el-select v-model="form.bornCountry">
          <el-option v-for="(item,i) in countryListArr" :key="i" :label="item.name" :value="item.short"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" label="出生地址城市：" prop="bornCity">
        <el-input v-model="form.bornCity" placeholder="英文或拼音"></el-input>
      </el-form-item>
      <el-form-item>
        <p style="width:336px;margin:10px 0 -20px -152px;color:#666;">是否可以提供税收居民国（地区）及纳税人识别号：</p>
      </el-form-item>
      <el-form-item v-if="form.type == '2'" prop="radio3">
        <el-radio-group v-model="form.radio3" class="radio-single-one">
          <el-radio :label="1">我可以提供</el-radio>
          <el-radio :label="0">我不能提供,请选择原因</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.type == '2' && form.radio3 == 1" label="税收居民国：" prop="taxCountry">
        <el-select v-model="form.taxCountry">
          <el-option v-for="(item,i) in countryListArr" :key="i" :label="item.name" :value="item.short"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type == '2' && form.radio3 == 1" label="纳税人识别号：" prop="taxNumber">
        <el-input v-model="form.taxNumber"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type == '2' && form.radio3 == 0" prop="reasonType">
        <el-select v-model="form.reasonType">
          <el-option label="居民国（地区）不发放纳税人识别号" value="1"></el-option>
          <el-option label="账户持有人未能取得纳税人识别号，如选此项，请填写具体原因:" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type == '2' && form.radio3 == 0 && form.reasonType == '2'" prop="reason">
        <el-input type="textarea" placeholder="请填写具体原因" v-model="form.reason"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label-width="15px" prop="checked" style="position: relative;">
        <el-checkbox class="checkbox-one" v-model="form.checked">
        </el-checkbox>
        <span class="read margin-t10">本人保证提供的信息真实、准确、完整，知晓并确认若提供的信息不真实、不准确、不完整的；应该依法承担相应的法律责任，展恒基金将不承担由此导致的关于适当性不匹配的任何后果，且有权拒绝销售产品或提供服务。本人已知晓并确认提供信息发生重要变化、可能影响投资者分类的，应当及时进行更新并告知展恒基金。</span>
      </el-form-item>
      <el-form-item>
        <el-button type="normal margin-t50" @click="submit">确认</el-button>
        <el-button type="cancel margin-t50" class="fr" @click="reback">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import datePicker from "../../components/lv-common/datePicker";
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: "fillInfo",
  components: {
    datePicker
  },
  data () {
    return {
      sourceDate: '',//出生日期
      //   表单
      form: {
        certificateno: '',
        vailddate: '',
        sex: '',
        birthday: '',
        china: '中国',
        occupation: '',
        province: [],
        address: '',
        // 控制,受益人
        controller: '1',
        controllerName: '',
        controllerIdType: '1',
        controllerId: '',
        controllerIdDate: '',
        controllerPhone: '',
        controllerExplain: '',
        beneficiary: '1',
        beneficiaryName: '',//
        beneficiaryIdType: '',
        beneficiaryId: '',
        beneficiaryIdDate: '',
        beneficiaryPhone: '',
        beneficiaryExplain: '',
        radio1: 0,
        // ---------------
        radio2: 0,
        illegalContent: '',
        // ---------------
        type: '1',
        lastname: '',
        firstname: '',
        sexRadio: '男',
        birthDate: '',
        nowCountry: 'CN',
        nowCity: '',
        nowAddress: '',
        bornCountry: 'CN',
        bornCity: '',
        radio3: 1,
        taxCountry: 'CN',
        taxNumber: '',
        reasonType: '1',
        reason: '',
        checked: true
      },
      formRules: {
        occupation: [//
          { required: true, message: '请选择职业', trigger: 'change' },
        ],
        address: [//
          { required: true, message: '请输入地址', trigger: 'blur' },
          { min: 8, message: '请填写详细地址，且不少于8个字符！', trigger: 'blur' }
        ],
        // 控制人
        controller: [//
          { required: true, message: '请选择实际控制人', trigger: 'change' },
        ],
        controllerName: [
          { required: true, message: '请输入控制人姓名', trigger: 'blur' },
        ],
        controllerIdType: [
          { required: true, message: '请选择身份证类型', trigger: 'change' },
        ],
        controllerId: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ],
        controllerIdDate: [
          { required: true, message: '请选择证件有效期', trigger: 'change' },
        ],
        controllerPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },//----------------------
        ],
        controllerExplain: [
          { required: true, message: '请输入情况说明', trigger: 'blur' },
        ],
        // 受益人   
        beneficiary: [//
          { required: true, message: '请选择实际受益人', trigger: 'change' },
        ],
        beneficiaryName: [
          { required: true, message: '请输入收益人姓名', trigger: 'blur' },
        ],
        beneficiaryIdType: [
          { required: true, message: '请选择身份证类型', trigger: 'blur' },
        ],
        beneficiaryId: [
          { required: true, message: '请输入证件号码', trigger: 'change' },
        ],
        beneficiaryIdDate: [
          { required: true, message: '请选择证件有效期', trigger: 'blur' },
        ],
        beneficiaryPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        beneficiaryExplain: [
          { required: true, message: '请输入情况说明', trigger: 'blur' },
        ],
        // 
        radio1: [
          { required: true, message: '请选择实际受益人是否为政要、国际组织高级管理人员或其亲属关系密切的人', trigger: 'change' },
        ],
        radio2: [//
          { required: true, message: '请选择是否有不良诚信记录', trigger: 'change' },
        ],
        illegalContent: [
          { required: true, message: '请描述不良记录！', trigger: 'blur' },
        ],
        // 税收居民身份声明
        type: [//
          { required: true, message: '请选择税收居民身份', trigger: 'change' },
        ],
        lastname: [
          { required: true, message: '请输入姓', trigger: 'blur' },
        ],
        firstname: [
          { required: true, message: '请输入名', trigger: 'blur' },
        ],
        sexRadio: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        nowCountry: [
          { required: true, message: '请选择现居地址国家', trigger: 'change' },
        ],
        nowCity: [
          { required: true, message: '请输入现居地址城市', trigger: 'blur' },
        ],
        nowAddress: [
          { required: true, message: '请填写详细地址', trigger: 'blur' },
          { min: 8, message: '请填写详细地址，且不少于8个字符！', trigger: 'blur' }
        ],
        // 
        bornCountry: [
          { required: true, message: '请选择出生地址国家', trigger: 'change' },
        ],
        bornCity: [
          { required: true, message: '请输入出生地址城市', trigger: 'blur' },
        ],
        radio3: [
          { required: true, message: '请选择是否可以提供税收居民国（地区）及纳税人识别号', trigger: 'change' },
        ],
        taxCountry: [
          { required: true, message: '请选择税收居民国', trigger: 'change' },
        ],
        taxNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
        ],
        reasonType: [
          { required: true, message: '请选择原因', trigger: 'change' },
        ],
        reason: [
          { required: true, message: '请输入具体原因', trigger: 'blur' },
        ],
      },
      optionsZq: [],
      //   数组
      professionArr: [],// 职业
      countryListArr: [],// 国家
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
    }
  },
  mounted () {
    this.optionsZq = regionData
    this.professionArr = this.$store.state.profession
    this.countryListArr = this.$store.state.countryList
    this.getUserInfo()
  },
  methods: {
    reback () {
      this.$emit('saveInfo', '2')
    },
    // 获取用户信息
    getUserInfo () {
      this.$http.post(this.$apiPath.queryAllInfo, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const custInfo = res.data.data
        // console.log(res);
        if (custInfo.accountIdcard) {//新开户的用户或完善信息后的用户
          this.form.birthday = this.$commonJs.getBirthday(custInfo.accountIdcard.identify)
          this.form.vailddate = this.$commonJs.getDateStrHg(custInfo.accountIdcard.valid)
          this.form.certificateno = custInfo.accountIdcard.identify
          this.form.sex = this.$commonJs.getSex(custInfo.accountIdcard.identify)
        } else {//旧用户
          this.form.certificateno = Base64.decode(this.$commonJs.getCookie('u_id'))
          this.form.sex = this.$commonJs.getSex(this.form.certificateno)
          this.form.birthday = this.$commonJs.getBirthday(this.form.certificateno)
          this.form.vailddate = this.$commonJs.getDateStrHg(custInfo.accountIdcard.valid)
        }
        // 判断职业
        if (custInfo.accountInfo && custInfo.accountInfo.profession) {
          this.form.occupation = custInfo.accountInfo.profession
        }
        // 判断用户地址-------------------
        if (custInfo.accountAddress) {
          // 详细地址
          this.form.address = custInfo.accountAddress.address ? custInfo.accountAddress.address : ((custInfo.accountIdcard && custInfo.accountIdcard.address) ? custInfo.accountIdcard.address : "--");
          // 地址
          let arr = []
          arr[0] = TextToCode[custInfo.accountAddress.province].code
          arr[1] = TextToCode[custInfo.accountAddress.province][custInfo.accountAddress.city].code
          arr[2] = TextToCode[custInfo.accountAddress.province][custInfo.accountAddress.city][custInfo.accountAddress.area].code
          this.form.province = arr
        } else if (custInfo.accountIdcard && custInfo.accountIdcard.address) {
          this.form.address = custInfo.accountIdcard.address
        }
        //实际控制人
        if (custInfo.accountControl) {
          if (custInfo.accountControl.isControl == "1") {
            this.form.controller = '1'
          } else {
            this.form.controller = '0'
            this.form.controllerName = custInfo.accountControl.name
            this.form.controllerId = custInfo.accountControl.identifyNo;
            let valid0 = custInfo.accountControl.valid;
            this.form.controllerIdDate = valid0.slice(0, 4) + "-" + valid0.slice(4, 6) + "-" + valid0.slice(6, 8);
            this.form.controllerPhone = custInfo.accountControl.contact;
          }
        }
        //实际受益人
        if (custInfo.accountBenefit) {
          if (custInfo.accountBenefit.isBenefit == "1") {
            this.form.beneficiary = '1'
          } else {
            this.form.beneficiary = '0'
            this.form.beneficiaryName = custInfo.accountBenefit.name;
            this.form.beneficiaryId = custInfo.accountBenefit.identifyNo;
            var valid1 = custInfo.accountBenefit.valid;
            this.form.beneficiaryIdDate = valid1.slice(0, 4) + "-" + valid1.slice(4, 6) + "-" + valid1.slice(6, 8);
            this.form.beneficiaryPhone = custInfo.accountBenefit.contact;
          }
        }
        //个税声明
        if (custInfo.accountTax) {
          if (custInfo.accountTax.taxStatus == "1") {
            this.form.type = '1'
          } else if (custInfo.accountTax.taxStatus == "3") {
            this.form.type = '3'
          } else if (custInfo.accountTax.taxStatus == "2") {
            this.form.type = '2'
            this.form.lastname = custInfo.accountTax.lastName
            this.form.firstname = custInfo.accountTax.firstName
            this.form.sexRadio = custInfo.accountTax.gender == '男' ? '男' : '女'
            // 出生日期
            this.sourceDate = custInfo.accountTax.birthday
            this.form.bornCountry = custInfo.accountTax.birthday
            this.form.nowCountry = custInfo.accountTax.liveCountry
            this.form.nowCity = custInfo.accountTax.liveCity
            this.form.nowAddress = custInfo.accountTax.liveAddress
            // 出生地址国家
            this.form.bornCountry = custInfo.accountTax.birthCountry
            this.form.bornCity = custInfo.accountTax.birthCity
            // 是否可以提供税收居民国（地区）及纳税人识别号
            if (custInfo.accountTax.provideTaxNo == "0") {//不能提供
              this.form.radio3 = 0
              if (custInfo.accountTax.taxNoReason == "1") {//居民国（地区）不发放纳税人识别号
                this.form.reasonType = '1'
              } else if (custInfo.accountTax.taxNoReason == "2") {//账户持有人未能取得纳税人识别号,具体原因如下
                this.form.reasonType = '2'
                this.form.reason = custInfo.accountTax.taxNoContent
              }
            } else if (custInfo.accountTax.provideTaxNo == "1") {//可以提供
              this.form.radio3 = 1
              this.form.taxCountry = custInfo.accountTax.taxCountry
              this.form.taxNumber = custInfo.accountTax.taxNo
            }
          }
        }
      }).catch(err => { })
    },
    submit () {
      // this.$emit('saveInfo', '4')
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.form.checked) {
          this.$message.error('请点击最后的保证按钮！')
        } else {
          this.$http.post(this.$apiPath.saveAllInfo, {
            custno: this.$commonJs.getCookie('u_custno1'),
            accountInfo: {//用户职业、诚信信息
              custno: this.$commonJs.getCookie('u_custno1'),
              profession: this.form.occupation,
              isIllegal: this.form.radio2,
              illegalContent: this.form.illegalContent,
            },
            accountControl: {//控制人
              custno: this.$commonJs.getCookie('u_custno1'),
              isControl: this.form.controller,
              name: this.form.controllerName,
              identifyType: '',
              identifyNo: this.form.controllerId,
              valid: this.form.controller.replace(/-/g, ''),
              contact: this.form.controllerPhone,//联系方式
              content: this.form.controllerExplain,//情况说明
            },
            accountTax: {//用户纳税人信息
              custno: this.$commonJs.getCookie('u_custno1'),
              taxStatus: this.form.type,
              firstName: this.form.firstname,
              lastName: this.form.lastname,
              gender: this.form.sexRadio,
              birthday: this.form.birthDate,//20210101
              liveCountry: this.form.nowCountry,//CN
              liveCity: this.form.nowCity,
              liveAddress: this.form.nowAddress,
              birthCountry: this.form.bornCountry,//CN
              birthCity: this.form.bornCity,
              provideTaxNo: this.form.radio3,// 0、不能提供；1、可以提供
              taxCountry: this.form.taxCountry,//CN
              taxNo: this.form.taxNumber,
              taxNoReason: this.form.reasonType,// 1、居民国不发放纳税人识别号；2、账户持有人未获取纳税人识别号
              taxNoContent: this.form.reason,
            },
            accountAddress: {//province（省）、city（市）、area（区）、address（详细地址）
              custno: this.$commonJs.getCookie('u_custno1'),
              province: CodeToText[this.form.province[0]],
              city: CodeToText[this.form.province[1]],
              area: CodeToText[this.form.province[2]],
              address: this.form.address,
            },
            accountBenefit: {//收益人
              custno: this.$commonJs.getCookie('u_custno1'),
              isBenefit: this.form.beneficiary,
              name: this.form.beneficiaryName,
              identifyType: '',
              identifyNo: this.form.beneficiaryId,
              valid: this.form.beneficiaryIdDate.replace(/-/g, ''),
              contact: this.form.beneficiaryPhone,
              content: this.form.beneficiaryExplain,
              isVip: this.form.radio1
            }
          }).then(res => {
            // console.log(res);
            if (res.data.code == "200" && res.data.success) {
              this.$emit('saveInfo', '4')
            } else {
              this.$message.error('信息完善失败')
            }
          }).catch(err => { })
        }

      })
    },
    // 日期选择
    birthDateClick (val) {
      if (val != '') {
        this.birthDate = this.$commonJs.timeFormat(val, 'yyyy-mm-dd')
        this.form.birthDate = this.birthDate.replace(/-/g, '')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.read {
  width: 580px;
  position: absolute;
  top: 0;
  left: 25px;
  font-size: 12px;
  line-height: 18px;
}
</style>